module.exports = __webpack_public_path__ + "static/img/1_1_4_3.42cda2e0.jpg";